import React, { useEffect, useState } from 'react';
import Form from 'olive-react-myoneui/lib/Form';
import Button from 'olive-react-myoneui/lib/Button';

import DropdownCommon from '../DropdownCommon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useDispatch, useSelector } from 'react-redux';
import { setContentFilterData, resetContentFilterData } from '../../../../reducers/contentFilterSlice';
import { validityFormatDate } from '../../../../helpers/datetime_helper';
import { getCatgories } from '../../../../api/afterLogin/categories';
import { closeIcon } from '../../../constants/icons';

const CourseFilter = ({className, onClickFilterSlide}) => {
    const configData = useSelector((state) => state.config);
    const [selectedRadio, setSelectedRadio] = useState('');
    const [selectedValidityDays, setSelectedValidityDays] = useState('');
    const [selectedValidityDate, setSelectedValidityDate] = useState(null);
    const [categories, setCategories] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState({
      enrollmentStatus: [],
      courseType: [], 
      category: [],
    });
    const [isPrevFilterSelected, setIsPrevFilterSelected] = useState(false);

    useEffect(() => {
      const categoryData = async () => {
        const categories = await getCatgories(configData.access_token);
        setCategories(categories.data);
      };
      categoryData();
    }, []);

    // Toggle selection for checkboxes
    const toggleCheckboxSelection = (group, value) => {
      setSelectedFilters(prevState => ({
        ...prevState,
        [group]: prevState[group].includes(value)
          ? prevState[group].filter(item => item !== value)
          : [...prevState[group], value],
      }));
      setIsPrevFilterSelected(true);
    };
  
    const resetFilters = () => {
      setSelectedFilters({
        enrollmentStatus: [],
        courseType: [],
        category: [],
      });
      setSelectedRadio('');
      setSelectedDate(null);
      setIsPrevFilterSelected(false);
    };
  
    const isApplyButtonEnabled = isPrevFilterSelected ? true :
      Object.values(selectedFilters).some(arr => arr.length > 0) || selectedRadio;


    const enrollmentStatusOptions = [
      { id: 1, name: 'All', value: 'all', label: 'All' },
      { id: 2, name: 'In Progress', value: 'inprogress', label: 'In Progress' },
      { id: 3, name: 'Not Started', value: 'not-started', label: 'Not Started' },
      { id: 4, name: 'Completed', value: 'completed', label: 'Completed' },
    ];

    const validityDays = [
        { id: 1, value: 12, name: "12 Days" },
        { id: 2, value: 30, name: "30 Days" },
        { id: 3, value: 90, name: "90 Days" },
        { id: 4, value: 120, name: "120 Days" },
        { id: 5, value: 365, name: "365 Days" }
    ];

    //Date Format 
    const formatedValidityDate = validityFormatDate(selectedValidityDate);

    const filteredValue = {
      selectedRadio,
      selectedValidityDays,
      formatedValidityDate,
      selectedFilters,
      categories
    }

    const dispatch = useDispatch();
    const handleApplyFilter = () => {
      dispatch(setContentFilterData(filteredValue));
      setIsPrevFilterSelected(Object.values(selectedFilters).some(arr => arr.length > 0));
    }

    const handleResetFilter = () => {
      dispatch(resetContentFilterData());
      resetFilters();
    }

  return (
    <div className={`myk__stu-courses-filter-wrapper ${className || ''}`}>
      <div className="myk__stu-filter-header d-flex align-items-center justify-content-between gap-2">
        <h3>Filter</h3>
        <span className="d-blok d-md-none p-2" role="button" onClick={onClickFilterSlide}>{closeIcon}</span>
      </div>
      {/* Enrollment Status Filter */}
      <div className="myk__stu-filter-inner-wrapper">
        <div className="myk__stu-filter-group">
          <h4>Enrollment Status</h4>
            <div className="myk__stu-filter-inner">
              {enrollmentStatusOptions.map(option => (
                <Form.Check
                  key={option.value}
                  className="mb-2"
                  label={option.label}
                  inline
                  id={`${option.value}-courses`}
                  onChange={() => toggleCheckboxSelection('enrollmentStatus', option.value)}
                  checked={selectedFilters.enrollmentStatus.includes(option.value)}
                />
            ))}
        </div>
      </div>

      {/* Course Validity Filter */}
      <div className="myk__stu-filter-group">
        <h4>Course Validity</h4>
        <Form.Check
          className="mb-2"
          type="radio"
          name="course-validity"
          label="Lifetime"
          inline
          id="validity-lifetime"
          onChange={() => setSelectedRadio('validity-lifetime')}
          checked={selectedRadio === 'validity-lifetime'}
        />
        <Form.Check className="mb-3 d-flex align-items-center" type="radio" id="validity-days">
          <Form.Check.Input
            name="course-validity"
            type="radio"
            onChange={() => setSelectedRadio('validity-days')}
            checked={selectedRadio === 'validity-days'}
          />
          <Form.Check.Label>
            <DropdownCommon
              label="Validity day(s)"
              items={validityDays}
              onChange={(selectedItem) => setSelectedValidityDays(selectedItem)}
              disabled={selectedRadio !== 'validity-days'}
            />
          </Form.Check.Label>
        </Form.Check>
        <Form.Check className="mb-2 d-flex align-items-center myk__stu-filterbydate" type="radio" id="validity-date">
          <Form.Check.Input
            name="course-validity"
            type="radio"
            onChange={() => setSelectedRadio('validity-date')}
            checked={selectedRadio === 'validity-date'}
          />
          <Form.Check.Label>
            <div className="myk_date-picker w-100">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker 
                  label="Select Date" 
                  disabled={selectedRadio !== 'validity-date'} 
                  value={selectedValidityDate}
                  onChange={(newValue) => setSelectedValidityDate(newValue)}
                  className="w-100" 
                />
              </LocalizationProvider>
            </div>

          </Form.Check.Label>
        </Form.Check>
        </div>
      </div>

      {/* Category Filter */}
      <div className="myk__stu-filter-group myk__stu-filterbycat">
        <h4>Category</h4>
        <div className="myk__stu-filter-inner">
            {categories && categories.map((category) => (
                <Form.Check
                    key={category.id}
                    className="mb-2"
                    label={category.ctName}
                    inline
                    id={`cat-${category.id}`}
                    onChange={() => toggleCheckboxSelection('category', category.id)}
                    checked={selectedFilters.category.includes(category.id)}
                />
            ))}
        </div>
      </div>

      {/* Filter Actions */}
      <div className="myk__stu-filter-actions d-flex align-items-center justify-content-end">
        <Button variant="default" className="" onClick={handleResetFilter}>Reset</Button>
        <Button variant="primary" className="" disabled={!isApplyButtonEnabled} onClick={handleApplyFilter}>Apply Filters</Button>
      </div>
    </div>
  );
}

export default CourseFilter;
